import type { FaireProductEntity } from "../../entity_types/product";

export const p_dk1ph1c8h1: FaireProductEntity = {
  token: "p_dk1ph1c8h1",
  type: "product",
  name: "IMC6265T",
  brandToken: "b_22tswwgnqb",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/036066fbf8b49219b08819df6d752add38bd41f80eb78142016b1830a4e104a2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7578ef3131e265d50023452a410ed79c0f5a38a5aec5df92eb5c14cea5ab92c0.jpeg",
    "https://cdn.faire.com/fastly/51919758ffba0246c701e0da1879e32b52e5a98cfc09640e5accd3f26c0377ff.jpeg",
    "https://cdn.faire.com/fastly/79080b46e0d9821ff724266415fca36cc34cdea1cc66f5f686b3ada2605261c0.jpeg",
    "https://cdn.faire.com/fastly/294eec845312d7b6732e4390b445b40fb5b2c9a4cfca819cf623c08712f5cfd6.jpeg",
    "https://cdn.faire.com/fastly/95c8ba76a0651ffe5dcc52cc3e49c70d7b170da55334951fd7f103764b864ac1.jpeg",
    "https://cdn.faire.com/fastly/8f1473e630a41393fa655b1847a77d14a834dd5488f0c31e4f42246732c1b6ab.jpeg",
    "https://cdn.faire.com/fastly/8336053a4ca94aa9902312047fef28275c42ec57673f9a6c88d33b653acc9aa0.jpeg",
    "https://cdn.faire.com/fastly/516d95a23f5db1d4dac96b708d7b1e51ec97a34a0e6dfccfe089b22d8a87363f.jpeg",
    "https://cdn.faire.com/fastly/1eff11929c9f611090f724895e72c858982c4b821f7759cb9cf29755e127fedc.jpeg",
    "https://cdn.faire.com/fastly/bd21feeca6a60960a492e00a47b47a945eb4f6e78e40e8f8008ac3c93d7949ef.jpeg",
    "https://cdn.faire.com/fastly/65fa019617d8b7823e404589090d620ce57baa3da35b11bbd62dd751c13b0e16.jpeg",
    "https://cdn.faire.com/fastly/89f250691ff6f4e03a6057c6c74af7f96a00ed1d4d2616002036b686512b7f01.jpeg",
    "https://cdn.faire.com/fastly/493688e55142a4bef042ac3c6950485e4cb2cfebfd5bdcfc4b29dbc8819d89cd.jpeg",
    "https://cdn.faire.com/fastly/d0e4a8a27d2f9a3b38abe510b911e244d1442e4c41800ae3122f660d94eebf88.jpeg",
    "https://cdn.faire.com/fastly/3a8924c8ca8c92b9d4877829cec48bfe48d912293a076351faf5579bda157d2a.jpeg",
    "https://cdn.faire.com/fastly/de0ce5e886af3f9b4badfc7826e77a4ecb4a552ccbf8724638aa7283d8ec2be0.jpeg",
    "https://cdn.faire.com/fastly/c4adffc8488ec77d5847b9ffdbf7ffa80afc8067cf00d646c56008cc49350c09.jpeg",
  ],
  priceDollars: 120.56,
  description:
    "BUTTON UP SPAGHETTI STRAP CROP TOP\n\nSIZE & FIT :\n\nModel Wears Size Small\nModel's Height: 5'9",
  tags: [],
  msrpDollars: 241.11,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:27.144Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
